import dashboards from './dashboards';
import apps from './apps';
import pages from './pages';
import cockpit, {
  assets,
  customers,
  maintenances,
  settings,
  // booking, // Booking temporariamente escondido — ver tarefa "Esconder o Booking".
  // Reativar: descomentar aqui e o `...booking` abaixo.
} from './cockpit';
import userInterface from './user-interface';

const navigation = [
  ...dashboards,
  ...cockpit,
  ...maintenances,
  ...assets,
  ...customers,
  // ...booking, // Booking temporariamente escondido do menu (ver import acima).
  ...settings,
];

export default navigation;
